
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlX as ObiOwnShipControlXElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-x.js';
 
 
 

 
 export const ObiOwnShipControlX = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-x',
   elementClass: ObiOwnShipControlXElement,
   events: {
     
   }
  });
 
 